
export class UpdateNodesCommand {
    constructor(targetId, oldNodes, newNodes, oldSelection, newSelection, callbacks) {
        this.targetId = targetId; // null (or undefined) for scene, string for prefab
        this.oldNodes = [...oldNodes];
        this.newNodes = [...newNodes];
        this.oldSelection = oldSelection ? [...oldSelection] : [];
        this.newSelection = newSelection ? [...newSelection] : [];
        this.callbacks = callbacks; // { setNodes, setPrefabs, setSelectedNodeIds }
    }

    apply(nodes, selection) {
        if (this.targetId) {
            this.callbacks.setPrefabs(prev => prev.map(p => p.id === this.targetId ? { ...p, nodes } : p));
        } else {
            this.callbacks.setNodes(nodes);
        }
        if (selection && this.callbacks.setSelectedNodeIds) {
            this.callbacks.setSelectedNodeIds(selection);
        }
    }

    execute() { this.apply(this.newNodes, this.newSelection); }
    undo() { this.apply(this.oldNodes, this.oldSelection); }
}

export class UpdatePrefabsListCommand {
    constructor(oldPrefabs, newPrefabs, oldSelection, newSelection, callbacks) {
        this.oldPrefabs = [...oldPrefabs];
        this.newPrefabs = [...newPrefabs];
        this.oldSelection = oldSelection;
        this.newSelection = newSelection;
        this.callbacks = callbacks; // { setPrefabs, setSelectedPrefabId }
    }

    execute() {
        this.callbacks.setPrefabs(this.newPrefabs);
        if (this.newSelection !== undefined && this.callbacks.setSelectedPrefabId) {
            this.callbacks.setSelectedPrefabId(this.newSelection);
        }
    }

    undo() {
        this.callbacks.setPrefabs(this.oldPrefabs);
        if (this.oldSelection !== undefined && this.callbacks.setSelectedPrefabId) {
            this.callbacks.setSelectedPrefabId(this.oldSelection);
        }
    }
}

export class CompositeCommand {
    constructor(commands) {
        this.commands = commands;
    }

    execute() {
        this.commands.forEach(cmd => cmd.execute());
    }

    undo() {
        // Undo in reverse order
        for (let i = this.commands.length - 1; i >= 0; i--) {
            this.commands[i].undo();
        }
    }
}

export class HistoryManager {
    constructor() {
        this.undoStack = [];
        this.redoStack = [];
    }

    execute(command) {
        command.execute();
        this.undoStack.push(command);
        this.redoStack = [];
    }

    // Use this when the change has already been applied to the state (e.g. after dragging)
    record(command) {
        this.undoStack.push(command);
        this.redoStack = [];
    }

    undo() {
        const cmd = this.undoStack.pop();
        if (!cmd) return
        cmd.undo();
        this.redoStack.push(cmd);
    }

    redo() {
        const cmd = this.redoStack.pop();
        if (!cmd) return
        cmd.execute();
        this.undoStack.push(cmd);
    }

    clear() {
        this.undoStack = [];
        this.redoStack = [];
    }
}